import { render } from "./SelectAutoUploader.vue?vue&type=template&id=59af454a&scoped=true"
import script from "./SelectAutoUploader.vue?vue&type=script&lang=js"
export * from "./SelectAutoUploader.vue?vue&type=script&lang=js"

import "./SelectAutoUploader.vue?vue&type=style&index=0&id=59af454a&scoped=true&lang=css"
import "./SelectAutoUploader.vue?vue&type=style&index=1&id=59af454a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59af454a"]])

export default __exports__